import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import FisHome from './views/FisHome.vue'
import RFIS from './views/RFIS.vue'
import ETHStake from './views/ETHStake.vue'
import ETHPool from './views/ETHPool.vue'
import ETHLiquefy from './views/ETHLiquefy.vue'
import FisAccountList from './views/FisAccountList.vue'
import FisRedeem from './views/FisRedeem.vue'
import RBridge from './views/RBridge.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/reth',
      name: 'reth',
      component: ETHStake
    },
    {
      path: '/fishome',
      name: 'fishome',
      component: FisHome
    },
    {
      path: '/fisaccountlist',
      name: 'fisaccountlist',
      component: FisAccountList
    },
    {
      path: '/fisredeem',
      name: 'fisredeem',
      component: FisRedeem
    },
    {
      path: '/rfis',
      name: 'rfis',
      component: RFIS
    },
    {
      path: '/ethpool',
      name: 'ethpool',
      component: ETHPool
    },
    {
      path: '/ethliquify',
      name: 'ethliquify',
      component: ETHLiquefy
    },
    {
      path: '/rbridge',
      name: 'rbridge',
      component: RBridge
    }
  ]
})
